var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRockLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 47,
    viewBox: "0 0 79 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4186 0H31.2541L30.6792 1.01279L22.9946 14.5524H9.21345H7.63068L7.26697 16.0928L0.580735 44.411L0 46.8706H2.52721H52.4773H76.4691H78.4691V44.8706V32.678V32.2277L78.2761 31.8208L63.7237 1.14283L63.1816 0H61.9167H32.4186ZM25.8985 17.5396L33.5832 4H60.6518L74.4691 33.1283V42.8706H52.4773H5.05443L10.7962 18.5524H24.1591H25.3237L25.8985 17.5396ZM44.2178 15.7658L49.7241 32.2847L51.6215 31.6522L46.1152 15.1333L44.2178 15.7658ZM64.6699 32.2847L57.5903 14.1925L59.4528 13.4637L66.5324 31.5559L64.6699 32.2847ZM25.3391 24.4186L19.8328 36.2178L21.6451 37.0636L27.1515 25.2643L25.3391 24.4186Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRockLogo);
export default __webpack_public_path__ + "static/media/Rock Logo.e5c56b37b5eed80f69ce7cd6559c577f.svg";
export { ForwardRef as ReactComponent };